import {action, computed, observable, makeObservable, runInAction} from 'mobx';
import {RuleModel} from '../baseModel';
import {savedSearchRuleDefaults} from './defaults';
import {SearchTypeSavedSearch, TSearchTypeSavedSearch} from './constants';
import type {SavedSearchRule} from './types';
import {validateSavedSearchRule} from './validate';

export class SavedSearchRuleModel
	extends RuleModel<TSearchTypeSavedSearch>
	implements SavedSearchRule
{
	readonly elementType = SearchTypeSavedSearch;
	elementSubType1: 4 = savedSearchRuleDefaults.elementSubType1;
	elementSubType2: 0 = savedSearchRuleDefaults.elementSubType2;
	elementValue1 = savedSearchRuleDefaults.elementValue1;
	elementValue2: '' = savedSearchRuleDefaults.elementValue2;
	elementValue3: '' = savedSearchRuleDefaults.elementValue3;

	get isValid() {
		return validateSavedSearchRule(this);
	}

	constructor(params?: Partial<Omit<SavedSearchRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, {...savedSearchRuleDefaults, ...params});
		});

		makeObservable(this, {
			elementValue1: observable,
			isValid: computed,
			setElementValue1: action,
		});
	}

	/** stubbed */
	setElementSubType1() {}

	/** stubbed */
	setElementSubType2() {}

	/**
	 * Set saved search id
	 * @param elementValue1 saved search id
	 */
	setElementValue1(elementValue1: number) {
		this.elementValue1 = elementValue1;
	}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default SavedSearchRuleModel;
